export default "/SMOL.6abedf216ccd9552bdbb989ecc8f7785.png";